module.exports = __webpack_public_path__ + "static/media/timer-saved.062cb30e.png";